module.exports = __webpack_public_path__ + "img/warning.f9fac9a7.svg";